module.exports = __webpack_public_path__ + "img/voyage_mobile.584b80a7.jpg";